import { useAppSelector } from "@/config/store";
import UserQuizAttemptsAccordion from "@/pages/courses/components/UserQuizAttemptsAccordion/UserQuizAttemptsAccordion";
import { Card, Pagination } from "@/components/ui";
import { IEdoCourseMaterial } from "@/shared/model/edo-course-material.model";
import { IEdoQuizAttempt } from "@/shared/model/edo-quiz-attempt.model";
import { IUser } from "@/shared/model/user.model";
import { EntityState } from "@/shared/reducers/reducer.utils";
import { ITEMS_PER_PAGE } from "@/shared/util/pagination.constants";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { useEffect, useState } from "react";
import { IPaginationBaseState, Translate } from "react-jhipster";
import { useNavigate, useParams } from "react-router-dom";

const QuizResultsRoute = () => {
  const params = useParams<{ id: string; courseQuizId: string }>();
  const navigate = useNavigate();
  const {
    loading: loadingMaterialeInsegnamento,
    totalItems: materialeInsegnamentoTotalItems,
    entities: courseMaterials,
    updateSuccess: updateSuccessCourseMaterial,
  } = useAppSelector<EntityState<IEdoCourseMaterial>>(
    (state) => state.edoCourseMaterial
  );
  const [paginationState, setPaginationState] = useState<IPaginationBaseState>({
    activePage: 1,
    itemsPerPage: ITEMS_PER_PAGE,
    sort: "order",
    order: "ASC",
  });
  const [courseMaterialToEdit, setCourseMaterialToEdit] =
    useState<IEdoCourseMaterial>(null);
  const [editCourseMaterialDialog, setEditCourseMaterialDialog] =
    useState<boolean>(false);
  const [users, setUsers] = useState<IUser[]>([]);

  const getAllEntities = async () => {
    const response = await axios.get<{ data: IUser[] }>(
      `/course-quizzes/${params.courseQuizId}/users`,
      {
        params: {
          page: paginationState.activePage,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        },
      }
    );
    setUsers(response.data.data);
  };

  useEffect(() => {
    getAllEntities();
  }, [
    paginationState.activePage,
    paginationState.order,
    paginationState.sort,
    paginationState.itemsPerPage,
  ]);

  const sort = (p: string) => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === "ASC" ? "DESC" : "ASC",
      sort: p,
    });
  };

  const handlePagination = (currentPage: number) =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleRowsPerPage = (rowsPerPage: number) =>
    setPaginationState({
      ...paginationState,
      itemsPerPage: rowsPerPage,
      activePage: 1,
    });

  const handleOpenAttempt = (quizAttempt: IEdoQuizAttempt) => {
    navigate(`/quiz-attempts/${quizAttempt.id}/review`);
  };

  return (
    <Card className="surface grid h-full grid-rows-[min-content_auto_min-content] overflow-hidden rounded-3xl p-0">
      <div className="border-b border-[var(--color-mockup-border)] bg-[var(--color-surface-secondary)]/50 dark:border-[var(--color-mockup-border)] dark:bg-[var(--color-surface-secondary)]/30">
        <div className="flex flex-wrap items-center justify-between gap-3 p-4">
          <h2 className="font-heading text-heading-3 font-bold text-[var(--color-mockup-text)]">
            <Translate contentKey="edocendoApp.edoQuizAttempt.home.title" />
          </h2>
        </div>
      </div>
      {loadingMaterialeInsegnamento ? (
        <div className="flex justify-center py-12">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
        </div>
      ) : (
        <div>
          {!users.length ? (
            <div className="p-4 text-center">
              <p className="text-body text-[var(--color-mockup-text-mid)]">
                <Translate contentKey="edocendoApp.edoQuizAttempt.home.notFound" />
              </p>
            </div>
          ) : (
            users.map((user) => (
              <UserQuizAttemptsAccordion
                key={user.id}
                user={user}
                onOpenAttempt={handleOpenAttempt}
                courseQuizId={parseInt(params.courseQuizId)}
              />
            ))
          )}
        </div>
      )}
      <Pagination
        count={materialeInsegnamentoTotalItems}
        page={paginationState.activePage - 1}
        rowsPerPage={paginationState.itemsPerPage}
        onPageChange={(page) => handlePagination(page + 1)}
        onRowsPerPageChange={handleRowsPerPage}
        labelRowsPerPage="Righe per pagina:"
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to} di ${count !== -1 ? count : "more than" + to}`
        }
      />
    </Card>
  );
};

export default QuizResultsRoute;
